import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 pb-16 px-4 sm:px-6 lg:px-8" data-id="element-55">
      {/* Background ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-cyan-glow/10 rounded-full blur-[120px] pointer-events-none" data-id="element-56" />

      <div className="relative z-10 max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center lg:text-left" data-id="element-58">
          <div className="inline-block mb-4 px-4 py-1.5 rounded-full border border-cyan-accent/30 bg-cyan-accent/10 text-cyan-glow text-sm font-semibold tracking-wider uppercase" data-id="element-59">
            Nuevo Lanzamiento
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-6" data-id="element-60">
            El Fin de la IA "Estúpida": El Manual del Método de 4 Capas{' '}
            <span className="text-cyan-glow text-glow block mt-2" data-id="element-61">
              (C-R-T-R)
            </span>
          </h1>
          <p className="text-lg sm:text-xl text-gray-300 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed" data-id="element-62">
            Deja de pelear con ChatGPT y conviértelo en tu empleado de élite con
            el sistema de prompt engineering que cualquiera puede usar en 30
            segundos.
          </p>

          <div className="flex flex-col items-center lg:items-start space-y-4" data-id="element-63">
            <CTAButton className="w-full sm:w-auto" href="#offer" data-id="element-64">
              ¡Quiero Dominar la IA Ahora!
            </CTAButton>
            <div className="flex items-center text-sm text-gray-400" data-id="element-65">
              <ShieldCheckIcon className="w-4 h-4 mr-2 text-cyan-accent" data-id="element-66" />
              <span data-id="element-67">Acceso instantáneo tras la compra. Pago 100% seguro.</span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative lg:h-[600px] flex justify-center items-center" data-id="element-68">
          <div className="absolute inset-0 bg-gradient-to-tr from-cyan-accent/20 to-electric/20 rounded-2xl blur-2xl transform rotate-3 scale-105" data-id="element-69" />
          <img src="https://cdn.magicpatterns.com/uploads/xieNivkLp3nfoGfutWnG22/heylloyd-image-1773619322728.png" alt="Mujer usando interfaz holográfica futurista" className="relative z-10 w-full max-w-md lg:max-w-full h-auto object-cover rounded-2xl border border-cyan-accent/30 shadow-[0_0_40px_rgba(0,229,255,0.2)] animate-float" data-id="element-70" />
        </motion.div>
      </div>
    </section>;
}